export enum Locale {
  EN_US = 'en',
  DE = 'de',
}

export const DEFAULT_LOCALE = Locale.DE;

export const AVAILABLE_LOCALES = [
  Locale.DE,
  Locale.EN_US,
];
